import { Alert, Group, Loader, Paper, Text, Title } from '@mantine/core'
import type { ReactNode } from 'react'

export function IntelligencePageHeader({
  title,
  description,
  action,
}: {
  title: string
  description: string
  action?: ReactNode
}) {
  return (
    <Group justify="space-between" align="flex-start" mb="xl">
      <div>
        <Title order={1} c="gray.9">
          {title}
        </Title>
        <Text c="gray.6" mt={3}>
          {description}
        </Text>
      </div>
      {action}
    </Group>
  )
}

export function QueryState({
  error,
  loading,
}: {
  error: unknown
  loading: boolean
}) {
  if (loading)
    return (
      <Group justify="center" py="xl">
        <Loader size="sm" />
        <Text c="dimmed">Loading from the connected service…</Text>
      </Group>
    )
  if (error)
    return (
      <Alert color="red" title="Service request failed">
        {error instanceof Error
          ? error.message
          : 'The connected service could not complete this request.'}
      </Alert>
    )
  return null
}

export function Empty({ message }: { message: string }) {
  return (
    <Paper withBorder p="xl" ta="center">
      <Text c="dimmed">{message}</Text>
    </Paper>
  )
}
